(function() {
  'use strict';
  /* gm-orders profile-track mobile 20260802v3 */
  if (window.__gmOrdersBooted) return;
  window.__gmOrdersBooted = true;

  var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';

  function profileOrdersLocked() {
    return window.__gmProfileOrdersLocked === true;
  }

  function lockProfileOrders(container) {
    window.__gmProfileOrdersLocked = true;
    if (container) container.dataset.gmOrdersReady = '1';
  }

  function orderImgTag(src, alt, eager) {
    if (!src) return '';
    var attrs = 'src="' + escHtml(src) + '" alt="' + escAttr(alt || '') + '" decoding="async"';
    attrs += eager ? ' loading="eager" fetchpriority="high"' : ' loading="eager"';
    return '<img ' + attrs + ' />';
  }

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(value) {
    return escHtml(value).replace(/'/g, '&#39;');
  }

  function formatPriceAmount(amount) {
    var n = parseFloat(amount);
    if (Number.isNaN(n)) return '$0';
    return n % 1 === 0 ? ('$' + n.toFixed(0)) : ('$' + n.toFixed(2));
  }

  function formatPreviewPrice(rawPrice) {
    var amount = parseFloat(rawPrice);
    if (!amount) return '';
    return amount % 1 === 0 ? ('$' + amount.toFixed(0)) : ('$' + amount.toFixed(2));
  }

  function productHasShopTag(product) {
    var tags = product.tags || '';
    if (Array.isArray(tags)) return tags.indexOf('SHOP ALL') >= 0;
    return String(tags).split(',').some(function(tag) { return tag.trim() === 'SHOP ALL'; });
  }

  async function fetchShopProductsForPreview() {
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var res = await fetch(root + 'collections/all/products.json?limit=250');
      if (!res.ok) return [];
      var data = await res.json();
      if (!data || !Array.isArray(data.products)) return [];
      return data.products.filter(function(product) {
        if (!productHasShopTag(product)) return false;
        if (String(product.title || '').trim().toLowerCase() === 'shipping') return false;
        return product.images && product.images.length;
      });
    } catch (e) {
      return [];
    }
  }

  function buildPreviewOrder(products) {
    var lineItems = [];
    var total = 0;
    var previewCount = 5;
    for (var i = 0; i < previewCount; i++) {
      var product = products[i % Math.max(products.length, 1)];
      if (!product && !lineItems.length) break;
      if (!product) continue;
      var variant = (product.variants && product.variants[0]) || {};
      var priceAmount = parseFloat(variant.price) || 20;
      total += priceAmount;
      lineItems.push({
        title: String(product.title || 'shop item').toLowerCase(),
        variant_title: variant.title ? String(variant.title).toLowerCase() : 'm',
        quantity: 1,
        price: formatPreviewPrice(variant.price) || '$20',
        image: product.images[0].src
      });
    }
    if (!lineItems.length) {
      lineItems = [
        { title: 'lazy boy knit beanie', variant_title: 'one size', quantity: 1, price: '$20', image: null },
        { title: 'logo tee', variant_title: 'm', quantity: 1, price: '$20', image: null },
        { title: 'studio hoodie', variant_title: 'l', quantity: 1, price: '$20', image: null },
        { title: 'logo cap', variant_title: 'one size', quantity: 1, price: '$20', image: null },
        { title: 'zip hoodie', variant_title: 'xl', quantity: 1, price: '$20', image: null }
      ];
      total = 100;
    }
    return {
      id: 'preview',
      name: '#981',
      created_at: '2026-08-22T00:00:00Z',
      created_at_label: '8/22/26',
      status_label: 'processing',
      total_price: formatPriceAmount(total),
      total_price_amount: total,
      line_items: lineItems,
      fulfillments: [{
        tracking_number: '91920181011',
        tracking_url: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=91920181011',
        tracking_company: 'USPS'
      }],
      is_preview: true
    };
  }

  function buildPreviewOrders(products) {
    var base = buildPreviewOrder(products);
    var items = getLineItems(base);
    var presets = [
      { name: '#981', status: 'processing', created_at: '2026-08-22T00:00:00Z', created_at_label: '8/22/26' },
      { name: '#974', status: 'delivered', created_at: '2026-07-14T00:00:00Z', created_at_label: '7/14/26' },
      { name: '#968', status: 'partially shipped', created_at: '2026-06-02T00:00:00Z', created_at_label: '6/2/26' },
      { name: '#955', status: 'confirmed', created_at: '2026-05-18T00:00:00Z', created_at_label: '5/18/26' }
    ];

    return presets.map(function(preset, index) {
      var orderItems;
      if (!items.length) {
        orderItems = [{ title: 'shop item', quantity: 1, price: '$20', image: null }];
      } else if (index === 0) {
        orderItems = items.slice();
      } else {
        var itemCount = Math.min(4, items.length);
        orderItems = [];
        for (var i = 0; i < itemCount; i++) {
          orderItems.push(items[(index + i) % items.length]);
        }
      }
      var amount = orderItems.reduce(function(sum, item) {
        var unit = parseFloat(String(item.price || '').replace(/[^0-9.]/g, '')) || 0;
        return sum + unit * (Number(item.quantity) || 1);
      }, 0);
      return {
        id: 'preview-' + index,
        name: preset.name,
        created_at: preset.created_at,
        created_at_label: preset.created_at_label,
        status_label: preset.status,
        total_price: formatPriceAmount(amount),
        total_price_amount: amount,
        line_items: orderItems,
        fulfillments: index === 0 ? (base.fulfillments || []) : [],
        is_preview: true
      };
    });
  }

  var previewOrdersFetchPromise = null;

  async function getPreviewOrders() {
    if (window.__gmPreviewOrdersCache) return window.__gmPreviewOrdersCache;
    if (previewOrdersFetchPromise) return previewOrdersFetchPromise;
    previewOrdersFetchPromise = fetchShopProductsForPreview().then(function(products) {
      window.__gmPreviewOrdersCache = buildPreviewOrders(products);
      return window.__gmPreviewOrdersCache;
    });
    return previewOrdersFetchPromise;
  }

  function collectOrderImageUrls(orders) {
    var urls = [];
    (orders || []).forEach(function(order) {
      getLineItems(order).forEach(function(item) {
        if (item && item.image) urls.push(item.image);
      });
    });
    return urls.filter(function(url, index) {
      return urls.indexOf(url) === index;
    });
  }

  function preloadOrderImages(orders) {
    var urls = collectOrderImageUrls(orders);
    if (!urls.length) return Promise.resolve();
    return Promise.all(urls.map(function(url) {
      return new Promise(function(resolve) {
        var img = new Image();
        img.onload = img.onerror = resolve;
        img.src = url;
      });
    }));
  }

  function getLineItems(order) {
    return (order && order.line_items) || [];
  }

  function getTrackingFulfillment(order) {
    if (!order || !order.fulfillments || !order.fulfillments.length) return null;
    for (var i = 0; i < order.fulfillments.length; i++) {
      var f = order.fulfillments[i];
      if (f.tracking_url || f.tracking_number) return f;
    }
    return order.fulfillments[0];
  }

  function getTotalItemQty(items) {
    return items.reduce(function(sum, item) {
      return sum + (Number(item.quantity) || 1);
    }, 0);
  }

  function formatOrderDateDisplay(order) {
    if (order && order.created_at) {
      var d = new Date(order.created_at);
      if (!Number.isNaN(d.getTime())) {
        return (d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).slice(-2);
      }
    }
    return String((order && order.created_at_label) || '').trim();
  }

  function buildStatusSteps(statusLabel) {
    var labels = ['confirmed', 'processing', 'shipped', 'delivered'];
    var activeIndex = 1;
    var status = String(statusLabel || '').toLowerCase();
    if (status === 'confirmed') activeIndex = 0;
    else if (status === 'processing') activeIndex = 1;
    else if (status === 'partially shipped') activeIndex = 2;
    else if (status === 'delivered') activeIndex = 3;
    else if (status === 'cancelled') {
      return '<p class="gm-order-status-cancelled">this order was cancelled</p>';
    }
    return '<ol class="gm-order-status-steps gm-order-status-steps--track">' +
      labels.map(function(label, index) {
        var cls = 'gm-order-status-step';
        if (index < activeIndex) cls += ' is-complete';
        if (index === activeIndex) cls += ' is-active';
        return '<li class="' + cls + '">' +
          '<span class="gm-order-status-box" aria-hidden="true"></span>' +
          '<span class="gm-order-status-label">' + escHtml(label) + '</span>' +
        '</li>';
      }).join('') +
    '</ol>';
  }

  function resolveTrackingUrl(fulfillment) {
    if (!fulfillment) return null;
    var url = fulfillment.tracking_url ? String(fulfillment.tracking_url).trim() : '';
    if (url) return url;

    var number = fulfillment.tracking_number
      ? String(fulfillment.tracking_number).replace(/^#/, '').trim()
      : '';
    if (!number) return null;

    var carrier = String(fulfillment.tracking_company || '').toLowerCase();

    if (carrier.indexOf('usps') >= 0 || carrier.indexOf('postal') >= 0 || carrier.indexOf('stamps') >= 0) {
      return 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + encodeURIComponent(number);
    }
    if (carrier.indexOf('ups') >= 0 || /^1z/i.test(number)) {
      return 'https://www.ups.com/track?tracknum=' + encodeURIComponent(number);
    }
    if (carrier.indexOf('fedex') >= 0 || carrier.indexOf('fed ex') >= 0) {
      return 'https://www.fedex.com/fedextrack/?trknbr=' + encodeURIComponent(number);
    }
    if (carrier.indexOf('dhl') >= 0) {
      return 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=' + encodeURIComponent(number);
    }
    if (carrier.indexOf('ontrac') >= 0) {
      return 'https://www.ontrac.com/tracking/?number=' + encodeURIComponent(number);
    }
    if (carrier.indexOf('lasership') >= 0) {
      return 'https://www.lasership.com/track/' + encodeURIComponent(number);
    }

    if (/^9[0-9]{21,25}$/.test(number)) {
      return 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + encodeURIComponent(number);
    }
    if (/^1z/i.test(number)) {
      return 'https://www.ups.com/track?tracknum=' + encodeURIComponent(number);
    }

    return null;
  }

  function buildTrackTrackingHtml(order) {
    var fulfillment = getTrackingFulfillment(order);
    var trackingNumber = fulfillment && fulfillment.tracking_number
      ? String(fulfillment.tracking_number).replace(/^#/, '')
      : '';
    if (!trackingNumber) {
      return '<div class="gm-order-tracking-block is-pending">' +
        '<p class="gm-order-tracking-value">—</p>' +
        '<p class="gm-order-tracking-label">tracking number</p>' +
      '</div>';
    }
    var trackingUrl = resolveTrackingUrl(fulfillment);
    var valueHtml = trackingUrl
      ? '<a class="gm-order-tracking-value" href="' + escHtml(trackingUrl) + '" target="_blank" rel="noopener noreferrer">' + escHtml(trackingNumber) + '</a>'
      : '<p class="gm-order-tracking-value">' + escHtml(trackingNumber) + '</p>';
    return '<div class="gm-order-tracking-block">' + valueHtml +
      '<p class="gm-order-tracking-label">tracking number</p>' +
    '</div>';
  }

  function getItemSizeLabel(item) {
    var size = String((item && (item.variant_title || item.size)) || '').trim();
    if (!size || /^default title$/i.test(size)) return '';
    return size.toLowerCase();
  }

  function buildTrackHeroBlockHtml(item) {
    var imgHtml = item.image
      ? orderImgTag(item.image, item.title, true)
      : '<div class="gm-order-track-hero-placeholder" aria-hidden="true"></div>';
    var size = getItemSizeLabel(item);
    return '<div class="gm-order-track-hero-media">' + imgHtml + '</div>' +
      '<p class="gm-order-track-hero-title">' + escHtml(String(item.title || 'item').toLowerCase()) + '</p>' +
      (size
        ? '<p class="gm-order-track-hero-size">' + escHtml(size) + '</p>'
        : '<p class="gm-order-track-hero-size" hidden></p>');
  }

  function buildHeroMediaHtml(item) {
    var imgHtml = item.image
      ? orderImgTag(item.image, item.title, true)
      : '<div class="gm-order-track-hero-placeholder" aria-hidden="true"></div>';
    return '<div class="gm-order-track-hero-media">' + imgHtml + '</div>';
  }

  function buildTrackStatsHtml(order, items) {
    return '<div class="gm-order-track-stats">' +
      '<div class="gm-order-track-stat">' +
        '<span class="gm-order-track-stat-value">' + escHtml(getTotalItemQty(items)) + '</span>' +
        '<span class="gm-order-track-stat-label">item qty</span>' +
      '</div>' +
      '<div class="gm-order-track-stat">' +
        '<span class="gm-order-track-stat-value">' + escHtml(order.total_price || '') + '</span>' +
        '<span class="gm-order-track-stat-label">order amount</span>' +
      '</div>' +
      '<div class="gm-order-track-stat">' +
        '<span class="gm-order-track-stat-value">' + escHtml(formatOrderDateDisplay(order)) + '</span>' +
        '<span class="gm-order-track-stat-label">order date</span>' +
      '</div>' +
    '</div>';
  }

  function buildThumbButtonHtml(item, index, isActive) {
    var img = item.image
      ? orderImgTag(item.image, item.title || 'item', false)
      : '<span class="gm-order-track-thumb-fallback" aria-hidden="true"></span>';
    return '<li><button type="button" class="gm-order-track-thumb' + (isActive ? ' is-active' : '') + '" data-item-index="' + index + '" aria-label="' + escAttr(String(item.title || 'item')) + '">' + img + '</button></li>';
  }

  function buildOverflowItemHtml(item, index) {
    var img = item.image
      ? orderImgTag(item.image, item.title || 'item', false)
      : '<span class="gm-order-track-thumb-fallback" aria-hidden="true"></span>';
    return '<li><button type="button" class="gm-order-track-overflow-item" data-order-overflow-item data-item-index="' + index + '" aria-label="' + escAttr(String(item.title || 'item')) + '">' +
      '<span class="gm-order-track-overflow-media">' + img + '</span>' +
      '<span class="gm-order-track-overflow-title">' + escHtml(String(item.title || 'item').toLowerCase()) + '</span>' +
    '</button></li>';
  }

  function buildTrackThumbsHtml(items) {
    if (items.length <= 1) return '';

    var thumbItems = items.slice(0, 3);
    var overflowItems = items.slice(3);
    var html = '<ul class="gm-order-track-thumbs" aria-label="items in this order">' +
      thumbItems.map(function(item, index) {
        return buildThumbButtonHtml(item, index, index === 0);
      }).join('');

    if (overflowItems.length) {
      html += '<li><button type="button" class="gm-order-track-thumb gm-order-track-thumb-more" data-order-thumb-more aria-expanded="false" aria-label="show ' + overflowItems.length + ' more items">+' +
        '<span class="gm-order-track-thumb-more-count">' + escHtml(overflowItems.length) + '</span></button></li>';
    }

    html += '</ul>';
    return html;
  }

  function buildTrackOverflowHtml(items) {
    var overflowItems = items.slice(3);
    if (!overflowItems.length) return '';

    return '<div class="gm-order-track-overflow" data-order-overflow hidden>' +
      '<ul class="gm-order-track-overflow-list" aria-label="more items in this order">' +
        overflowItems.map(function(item, index) {
          return buildOverflowItemHtml(item, index + 3);
        }).join('') +
      '</ul></div>';
  }

  function buildPastHeroMediaHtml(item) {
    var imgHtml = item.image
      ? orderImgTag(item.image, item.title, false)
      : '<div class="gm-order-past-hero-placeholder" aria-hidden="true"></div>';
    return '<div class="gm-order-past-hero-media">' + imgHtml + '</div>';
  }

  function buildPastThumbButtonHtml(item, index, isActive) {
    var img = item.image
      ? orderImgTag(item.image, item.title || 'item', false)
      : '<span class="gm-order-past-thumb-fallback" aria-hidden="true"></span>';
    return '<li><button type="button" class="gm-order-past-thumb' + (isActive ? ' is-active' : '') + '" data-item-index="' + index + '" aria-label="' + escAttr(String(item.title || 'item')) + '">' + img + '</button></li>';
  }

  function buildPastThumbsHtml(items) {
    if (items.length <= 1) return '';

    var thumbItems = items.slice(0, 3);
    var overflowItems = items.slice(3);
    var html = '<ul class="gm-order-past-thumbs" aria-label="items in this order">' +
      thumbItems.map(function(item, index) {
        return buildPastThumbButtonHtml(item, index, index === 0);
      }).join('');

    if (overflowItems.length) {
      html += '<li><span class="gm-order-past-thumb gm-order-past-thumb-more" aria-label="' + overflowItems.length + ' more items">+' +
        '<span class="gm-order-past-thumb-more-count">' + escHtml(overflowItems.length) + '</span></span></li>';
    }

    html += '</ul>';
    return html;
  }

  function buildPastOrderCard(order) {
    var items = getLineItems(order);
    if (!items.length) {
      items = [{ title: 'order item', quantity: 1, price: order.total_price || '', image: null }];
    }
    var orderName = String(order.name || '').toLowerCase();
    if (orderName && orderName.charAt(0) !== '#') orderName = '#' + orderName;
    var status = String(order.status_label || 'delivered').toLowerCase();
    var thumbsHtml = buildPastThumbsHtml(items);
    var itemsJson = escAttr(JSON.stringify(items));

    return '<article class="gm-order-past-card" role="button" tabindex="0" aria-label="view order ' + escAttr(orderName) + '" data-order-id="' + escHtml(order.id) + '" data-order-items="' + itemsJson + '">' +
      '<h3 class="gm-order-past-title">order ' + escHtml(orderName) + '</h3>' +
      '<div class="gm-order-past-items' + (items.length > 1 ? '' : ' is-single-item') + '">' +
        '<div class="gm-order-past-main">' +
          '<div class="gm-order-past-hero" data-order-hero data-active-index="0">' + buildPastHeroMediaHtml(items[0]) + '</div>' +
          '<p class="gm-order-past-status">' + escHtml(status) + '</p>' +
        '</div>' +
        (thumbsHtml ? '<div class="gm-order-past-side">' + thumbsHtml + '</div>' : '') +
      '</div>' +
    '</article>';
  }

  function buildPastOrdersSection(pastOrders) {
    if (!pastOrders.length) return '';
    return '<section class="gm-order-past-section">' +
      '<h2 class="gm-order-past-heading">past orders</h2>' +
      '<div class="gm-order-past-grid">' +
        pastOrders.map(function(order) { return buildPastOrderCard(order); }).join('') +
      '</div>' +
    '</section>';
  }

  function buildPreviewPastOrders(products) {
    products = products || [];
    function makeOrder(name, status, offset) {
      var lineItems = [];
      for (var i = 0; i < 4; i++) {
        var product = products[(offset + i) % Math.max(products.length, 1)];
        if (!product && !lineItems.length) break;
        if (!product) continue;
        lineItems.push({
          title: String(product.title || 'shop item').toLowerCase(),
          quantity: 1,
          price: '$20',
          image: product.images && product.images[0] ? product.images[0].src : null
        });
      }
      if (!lineItems.length) {
        lineItems = [
          { title: 'lazy boy knit beanie', quantity: 1, price: '$20', image: null },
          { title: 'logo tee', quantity: 1, price: '$20', image: null },
          { title: 'studio hoodie', quantity: 1, price: '$20', image: null },
          { title: 'logo cap', quantity: 1, price: '$20', image: null }
        ];
      }
      return {
        id: 'preview-past-' + name.replace('#', ''),
        name: name,
        created_at: name === '#912' ? '2026-06-10T00:00:00Z' : '2026-05-22T00:00:00Z',
        created_at_label: name === '#912' ? '6/10/26' : '5/22/26',
        status_label: status,
        total_price: formatPriceAmount(lineItems.length * 20),
        total_price_amount: lineItems.length * 20,
        line_items: lineItems,
        fulfillments: [{
          tracking_number: name === '#912' ? '9400111899223344556677' : '91920181099',
          tracking_url: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' +
            (name === '#912' ? '9400111899223344556677' : '91920181099'),
          tracking_company: 'USPS'
        }],
        is_preview: true
      };
    }
    return [
      makeOrder('#912', 'delivered', 0),
      makeOrder('#812', 'delivered', 1)
    ];
  }

  function ensureProfilePastGridStyles() {
    if (document.getElementById('gm-profile-past-grid-styles')) return;
    if (!document.querySelector('.gm-profile-page')) return;
    var style = document.createElement('style');
    style.id = 'gm-profile-past-grid-styles';
    style.textContent = '@media (max-width:749px){.gm-profile-page .gm-order-past-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:1.25rem .65rem!important;justify-content:stretch!important}.gm-profile-page .gm-order-past-card{width:100%!important;min-width:0!important}.gm-profile-page .gm-order-past-title{font-size:.78rem!important;letter-spacing:.08em!important;margin-bottom:.5rem!important}.gm-profile-page .gm-order-past-hero-media,.gm-profile-page .gm-order-past-hero-placeholder{width:min(7.5rem,36vw)!important;height:min(7.5rem,36vw)!important;max-width:100%!important}.gm-profile-page .gm-order-past-thumb,.gm-profile-page .gm-order-past-thumb-more{width:min(2.35rem,11vw)!important;height:min(2.35rem,11vw)!important}.gm-profile-page .gm-order-past-status{font-size:.72rem!important;margin-top:.45rem!important}.gm-profile-page .gm-order-past-items:not(.is-single-item){width:100%!important;max-width:100%!important;gap:.35rem!important}}';
    document.head.appendChild(style);
  }

  function renderSignedInTrackView(container, currentOrder, pastOrders) {
    if (!container) return;
    ensureProfilePastGridStyles();
    pastOrders = pastOrders || [];
    container.__gmOrderState = {
      current: currentOrder,
      past: pastOrders.slice()
    };
    container.innerHTML =
      '<div class="gm-order-current">' + buildTrackOrderView(currentOrder) + '</div>' +
      buildPastOrdersSection(pastOrders);
    bindTrackOrderViews(container);
    bindPastOrderClicks(container);
  }

  function swapToPastOrder(container, orderId) {
    var state = container && container.__gmOrderState;
    if (!state || !orderId) return;

    var pastIndex = -1;
    for (var i = 0; i < state.past.length; i++) {
      if (String(state.past[i].id) === String(orderId)) {
        pastIndex = i;
        break;
      }
    }
    if (pastIndex < 0) return;

    var selected = state.past[pastIndex];
    var previous = state.current;
    var nextPast = state.past.slice();
    nextPast.splice(pastIndex, 1);
    nextPast.unshift(previous);

    renderSignedInTrackView(container, selected, nextPast);

    var currentEl = container.querySelector('.gm-order-current');
    if (currentEl && typeof currentEl.scrollIntoView === 'function') {
      currentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function bindPastOrderClicks(container) {
    if (!container) return;
    container.querySelectorAll('.gm-order-past-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('button')) return;
        swapToPastOrder(container, card.getAttribute('data-order-id'));
      });

      card.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest('button')) return;
        e.preventDefault();
        swapToPastOrder(container, card.getAttribute('data-order-id'));
      });
    });
  }

  function buildTrackOrderView(order) {
    var items = getLineItems(order);
    if (!items.length) {
      items = [{ title: 'order item', quantity: 1, price: order.total_price || '', image: null }];
    }
    var orderName = String(order.name || '').toLowerCase();
    if (orderName && orderName.charAt(0) !== '#') orderName = '#' + orderName;
    var thumbsHtml = buildTrackThumbsHtml(items);
    var overflowHtml = buildTrackOverflowHtml(items);
    var itemsJson = escAttr(JSON.stringify(items));

    return '<article class="gm-order-track-view" data-order-id="' + escHtml(order.id) + '" data-order-items="' + itemsJson + '">' +
      '<h2 class="gm-order-track-heading">order ' + escHtml(orderName) + '</h2>' +
      '<div class="gm-order-track-items' + (items.length > 1 ? '' : ' is-single-item') + '">' +
        '<div class="gm-order-track-hero" data-order-hero data-active-index="0">' + buildTrackHeroBlockHtml(items[0]) + '</div>' +
        (thumbsHtml ? '<div class="gm-order-track-side">' + thumbsHtml + '</div>' : '') +
      '</div>' +
      overflowHtml +
      buildTrackStatsHtml(order, items) +
      '<div class="gm-order-track-footer">' +
        buildStatusSteps(order.status_label) +
        buildTrackTrackingHtml(order) +
      '</div>' +
    '</article>';
  }

  function selectTrackOrderItem(view, items, index) {
    var hero = view.querySelector('[data-order-hero]');
    if (!hero || !items[index]) return;

    hero.setAttribute('data-active-index', String(index));
    if (view.classList.contains('gm-order-past-card')) {
      hero.innerHTML = buildPastHeroMediaHtml(items[index]);
    } else {
      hero.innerHTML = buildTrackHeroBlockHtml(items[index]);
    }

    view.querySelectorAll('.gm-order-track-thumb[data-item-index], .gm-order-past-thumb[data-item-index]').forEach(function(btn) {
      var btnIndex = parseInt(btn.getAttribute('data-item-index'), 10);
      btn.classList.toggle('is-active', btnIndex === index);
    });

    view.querySelectorAll('[data-order-overflow-item]').forEach(function(btn) {
      var btnIndex = parseInt(btn.getAttribute('data-item-index'), 10);
      btn.classList.toggle('is-active', btnIndex === index);
    });
  }

  function bindTrackOrderViews(container) {
    if (!container) return;
    container.querySelectorAll('.gm-order-track-view, .gm-order-past-card').forEach(function(view) {
      if (view.__gmBound) return;
      view.__gmBound = true;

      var items = [];
      try {
        items = JSON.parse(view.getAttribute('data-order-items') || '[]');
      } catch (e) {
        items = [];
      }
      if (!items.length) return;

      view.querySelectorAll('.gm-order-track-thumb[data-item-index], .gm-order-past-thumb[data-item-index]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var index = parseInt(btn.getAttribute('data-item-index'), 10);
        selectTrackOrderItem(view, items, index);
        var overflow = view.querySelector('[data-order-overflow]');
        var moreBtn = view.querySelector('[data-order-thumb-more]');
        if (overflow) overflow.hidden = true;
        if (moreBtn) {
          moreBtn.classList.remove('is-open');
          moreBtn.setAttribute('aria-expanded', 'false');
        }
      });
    });

      var moreBtn = view.querySelector('[data-order-thumb-more]');
      var overflow = view.querySelector('[data-order-overflow]');
      if (moreBtn && overflow) {
        moreBtn.addEventListener('click', function() {
          var willOpen = overflow.hidden;
          overflow.hidden = !willOpen;
          moreBtn.classList.toggle('is-open', willOpen);
          moreBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      }

      view.querySelectorAll('[data-order-overflow-item]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var index = parseInt(btn.getAttribute('data-item-index'), 10);
          selectTrackOrderItem(view, items, index);
        });
      });
    });
  }

  function buildOrderCard(order, options) {
    options = options || {};
    var primary = getLineItems(order)[0] || { title: 'order', image: null };
    var imgHtml = primary.image
      ? '<img src="' + escHtml(primary.image) + '" alt="' + escHtml(primary.title) + '" loading="lazy" />'
      : '';
    var orderName = String(order.name || '').toLowerCase();
    var meta = 'ordered ' + escHtml(order.created_at_label) +
      ' · ' + escHtml(orderName) +
      ' · ' + escHtml(order.total_price) +
      ' · ' + escHtml(order.status_label);

    if (options.compact) {
      return '<li class="gm-profile-order-item">' +
        '<div class="gm-profile-order-media">' + imgHtml + '</div>' +
        '<div class="gm-profile-order-info">' +
          '<span class="gm-profile-order-name">' + escHtml(String(primary.title || '').toLowerCase()) + '</span>' +
          '<span class="gm-profile-order-meta">' + meta + '</span>' +
        '</div>' +
      '</li>';
    }

    return buildTrackOrderView(order);
  }

  function getOrdersSummary(orders) {
    var count = orders.length;
    var total = orders.reduce(function(sum, order) {
      return sum + (order.total_price_amount || 0);
    }, 0);
    return {
      count: count,
      totalFormatted: formatPriceAmount(total)
    };
  }

  function buildOrdersSummaryHtml(summary) {
    return '<div class="gm-profile-orders-summary">' +
      '<div class="gm-profile-orders-stat">' +
        '<span class="gm-profile-orders-stat-value">' + summary.count + '</span>' +
        '<span class="gm-profile-orders-stat-label">orders</span>' +
      '</div>' +
      '<div class="gm-profile-orders-stat">' +
        '<span class="gm-profile-orders-stat-value">' + escHtml(summary.totalFormatted) + '</span>' +
        '<span class="gm-profile-orders-stat-label">total spend</span>' +
      '</div>' +
    '</div>';
  }

  async function callOrdersApi(body, token) {
    var headers = {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY
    };
    if (token) headers.Authorization = 'Bearer ' + token;
    var res = await fetch(SUPABASE_URL + '/functions/v1/shopify-orders', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    });
    var data = null;
    try { data = await res.json(); } catch (e) { /* empty */ }
    if (!res.ok || !data) {
      return {
        ok: false,
        error: (data && data.error) || ('request failed (' + res.status + ')'),
        orders: []
      };
    }
    return {
      ok: !!data.ok,
      error: data.error || null,
      hint: data.hint || null,
      orders: Array.isArray(data.orders) ? data.orders : []
    };
  }

  async function fetchMyOrders(token) {
    if (!token) return { ok: false, error: 'sign in required', orders: [] };
    return callOrdersApi({ mode: 'mine' }, token);
  }


  async function getPreviewOrder() {
    var orders = await getPreviewOrders();
    return orders[0] || buildPreviewOrder([]);
  }

  function isLocalThemePreview() {
    var host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  }

  function shouldShowPreviewProfileOrders() {
    if (!isLocalThemePreview()) return false;
    try {
      if (localStorage.getItem('gm-preview-profile-orders') === '1') return true;
    } catch (e) {
      /* ignore */
    }
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    return /(?:\?|&)preview_orders=1(?:&|$)/.test(search) ||
      /preview_orders=1/.test(hash);
  }

  async function waitForGmOrders(maxMs) {
    var deadline = Date.now() + (maxMs || 4000);
    while (Date.now() < deadline) {
      if (window.__gmOrders && typeof window.__gmOrders.renderProfileOrders === 'function') {
        return window.__gmOrders;
      }
      await new Promise(function(resolve) {
        window.setTimeout(resolve, 50);
      });
    }
    return window.__gmOrders || null;
  }

  function renderProfileOrders(container, orders, message) {
    if (!container) return;
    if (container.__gmProfileOrdersRendering) return;
    if (container.querySelector('.gm-order-track-view')) {
      lockProfileOrders(container);
      ensureProfilePastGridStyles();
      return;
    }
    if (profileOrdersLocked()) {
      ensureProfilePastGridStyles();
      return;
    }
    if (!orders.length) {
      container.innerHTML = '<p class="gm-profile-orders-empty">' +
        escHtml(message || 'you haven\u2019t placed any orders yet.') +
      '</p>';
      lockProfileOrders(container);
      return;
    }

    container.__gmProfileOrdersRendering = true;
    lockProfileOrders(container);
    try {
      var summary = getOrdersSummary(orders);
      container.innerHTML = buildOrdersSummaryHtml(summary) +
        '<div class="gm-profile-order-results"></div>';
      var results = container.querySelector('.gm-profile-order-results');
      renderSignedInTrackView(results, orders[0], orders.slice(1));
      container.classList.remove('gm-profile-orders--pending');
    } finally {
      container.__gmProfileOrdersRendering = false;
    }
  }

  window.__gmOrders = {
    fetchMyOrders: fetchMyOrders,
    getPreviewOrder: getPreviewOrder,
    getPreviewOrders: getPreviewOrders,
    preloadOrderImages: preloadOrderImages,
    buildPreviewOrder: buildPreviewOrder,
    buildPreviewOrders: buildPreviewOrders,
    renderProfileOrders: renderProfileOrders,
    renderSignedInTrackView: renderSignedInTrackView,
    shouldShowPreviewProfileOrders: shouldShowPreviewProfileOrders,
    waitForGmOrders: waitForGmOrders
  };

  window.dispatchEvent(new CustomEvent('gm-orders-ready'));
})();
